import React from 'react'

function Info() {
  return (
    <div className='bg-white h-64'>
      <div className='text-center mb-48 mt-32'>
      <p className='text-[#2B2B2B] text-3xl font-bold mx-auto pt-14'>
        Some Dummy Text Will Be Here For Now Yet</p>
      <p className='text-gray-700 px-4'>
       Some dummy text will be here for now
      </p>
      </div>
    </div>
  );
}

export default Info
